import { render, staticRenderFns } from "./PlanOrFeeInactive.vue?vue&type=template&id=d86c2664&scoped=true"
import script from "./PlanOrFeeInactive.vue?vue&type=script&lang=js"
export * from "./PlanOrFeeInactive.vue?vue&type=script&lang=js"
import style0 from "./PlanOrFeeInactive.vue?vue&type=style&index=0&id=d86c2664&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d86c2664",
  null
  
)

export default component.exports